import { Component, EventEmitter, Input, OnInit, Optional, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { CategorieHierarchiqueModel } from '../../models/CategorieHierarchiqueModel';
import { CacheService } from '../../services/cache-service';
import { ConfigurationService } from '../../services/configuration.service';
import { GuidService } from '../../services/guid.service';

@Component({
  selector: 'app-categorie-hierarchique-dropdown',
  templateUrl: './categorie-hierarchique-dropdown.component.html',
  styleUrl: './categorie-hierarchique-dropdown.component.css',
  viewProviders: [
    {
      provide: ControlContainer,
      deps: [[Optional, NgForm]],
      useFactory: (ngForm: NgForm) => ngForm
    }
  ]
})
export class CategorieHierarchiqueDropdownComponent implements OnInit {
  @Input() editMode: boolean = true;
  @Input() showClear: boolean = false;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() placeholder: string = ''; // Sélectionner un taux de TVA
  pDropdownStyle: any = {};
  minWidth: string = '84px';

  private _categorieId: number;
  @Input()
  set categorieId(value: number) {
    this._categorieId = value;
    this.selectStatut();
  }
  get categorieId(): number {
    return this._categorieId;
  }

  _categorie: CategorieHierarchiqueModel = null;
  @Input()
  set categorie(value: CategorieHierarchiqueModel) {
    this._categorie = value;
    this._categorieId = value?.Id;
  }
  get categorie(): CategorieHierarchiqueModel {
    return this._categorie ? this._categorie : null;
  }
 
  @Input() inputFocus: string;
  @Input() inputFocusValue: string;

  @Output() categorieIdChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() categorieChange: EventEmitter<CategorieHierarchiqueModel> = new EventEmitter<CategorieHierarchiqueModel>();
  @Output() inputFocusChange: EventEmitter<string> = new EventEmitter<string>();

  public categories: CategorieHierarchiqueModel[] = [];
  public guid: string;
  public categoriesLoaded: boolean = false;

  constructor(
    configurationService: ConfigurationService,
    private guidService: GuidService,
    private cacheService: CacheService
  ) {
    this.pDropdownStyle = { ...configurationService.pDropdownStyle, 'min-width': this.minWidth };
  }

  ngOnInit() {
    this.guid = this.guidService.newGuid();
    if (!this.categoriesLoaded) {
      this.loadStatuts();
    } else {
      this.selectStatut();
    }
  }

  selectStatut() {
    if (this.categoriesLoaded) {
      setTimeout(() => {
        this.categorie = this.categories.find((t) => this._categorieId != null && this._categorieId != undefined && t.Id == this._categorieId);
      });
    }
  }

  loadStatuts() {
    this.cacheService.getCategorieHierarchiques().subscribe((categories) => {
      this.categories = categories;
      this.categoriesLoaded = true;
      this.selectStatut();
    });
  }

  inputFocusChanged(value) {
    this.inputFocus = value;
    this.inputFocusChange.emit(this.inputFocus);
  }

  categorieChanged() {
    if (this.categoriesLoaded) {
      if (this._categorieId != this._categorie?.Id) {
        this._categorieId = this._categorie?.Id;
        this.categorieIdChange.emit(this._categorieId);
        this.categorieChange.emit(this._categorie);
      }
    }
  }
}
